<template>
  <report-page
    :title="name"
    :data-to-send="dataToSend"
    :buttons-disabled="buttonsDisabled"
    :history-filter="historyFilter"
    :selectedWorkspaceUUID="selectedWorkspace"
  >
    <template v-slot:reportForm>
      <report-field :field-name="$tc('Workspace', 1)">
        <treeselect
          v-model="selectedWorkspace"
          :options="workspaceOptions"
          :disabled="
            workspaceSelectionDisabled ||
              !userHasManagementPermission('workspace', 'list') ||
              !hasPermissionToCreateExport
          "
          disableFuzzyMatching
        />
      </report-field>

      <report-field :field-name="$tc(reportParameters[0].label, 1)">
        <treeselect
          :value="reportParameters[0].value"
          @input="updateType"
          :options="typeOptions"
          :load-options="loadTypeOptions"
          value-format="object"
          :disabled="
            !hasPermissionToCreateExport || selectedWorkspace === undefined
          "
          disableFuzzyMatching
        />
      </report-field>

      <report-field
        :field-name="$tc(reportParameters[1].label, 2)"
        v-if="needsLayerSelection"
      >
        <treeselect
          v-model="reportParameters[1].value"
          :options="objectOptions"
          :load-options="loadObjectOptions"
          :multiple="layersFieldIsMultiSelect"
          :disabled="
            !hasPermissionToCreateExport ||
              reportParameters[0].value === undefined
          "
          disableFuzzyMatching
        />
      </report-field>
    </template>
  </report-page>
</template>

<script>
import ReportPage from "../ReportPage";
import ReportField from "../ReportField";
import { mapActions } from "vuex";
import { homeReportPageMixin } from "@/mixins/homeReportPageMixin";

export default {
  name: "RawDataReports",

  components: {
    ReportField,
    ReportPage
  },

  mixins: [homeReportPageMixin],

  props: {
    name: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      reportParameters: [
        {
          label: "Type",
          key: "type",
          type: "text",
          value: undefined
        },
        {
          label: "Object",
          key: "layers",
          type: "array",
          value: undefined
        }
      ],

      typeOptions: null,
      objectOptions: null,

      historyFilter:
        "shape,sqlite,specific_exportation,byon_specific_exportation"
    };
  },

  computed: {
    buttonsDisabled() {
      return (
        !this.reportParameters[0].value ||
        (this.needsLayerSelection && !this.reportParameters[1].value)
      );
    },

    /**
     * Determines if the Layers field should be multi-select or not.
     */
    layersFieldIsMultiSelect() {
      if (this.reportParameters[0].value === undefined) {
        return false;
      } else {
        return !this.reportParameters[0].value.just_select_one;
      }
    },

    needsLayerSelection() {
      let type = this.reportParameters[0].value;
      if (!type) {
        return false;
      }
      return type.need_select_objects;
    },

    dataToSend() {
      let type = this.reportParameters[0].value;
      let layers = this.reportParameters[1].value;
      if (type !== undefined) {
        let dataJSON = {
          type: type.type,
          version: type.id,
          objects: {
            workspace_uuid: this.selectedWorkspace,
            layers: null
          }
        };

        if (this.needsLayerSelection && layers !== undefined) {
          dataJSON.objects.layers = [];
          if (typeof layers === "object") {
            layers.forEach(layer => {
              dataJSON.objects.layers.push({ name: layer });
            });
          } else {
            dataJSON.objects.layers.push({ name: layers });
          }
        }
        return dataJSON;
      } else return {};
    }
  },

  watch: {
    selectedWorkspace() {
      this.resetReportParameterValues(this.reportParameters, 0);

      this.typeOptions = null;
      this.objectOptions = null;
    }
  },

  mounted() {
    this.setWorkspaceField();
  },

  methods: {
    ...mapActions([
      "GET_EXPORT_MAPPER_TEMPLATES_BY_PAGE",
      "getObjectsToSelectInExport"
    ]),

    /**
     * Loads the list of types of file available for the selected workspace.
     */
    loadTypeOptions({ callback }) {
      if (this.selectedWorkspace) {
        this.GET_EXPORT_MAPPER_TEMPLATES_BY_PAGE("RawDataReport")
          .then(types => {
            this.typeOptions = [];
            for (const key of Object.keys(types)) {
              let type = types[key];
              this.typeOptions.push({
                id: type.version,
                label: type.name,
                version: type.version,
                type: type.type,
                layers: type.layers,
                just_select_one: type.just_select_one,
                need_select_objects: type.need_select_objects
              });
            }
            callback();
          })
          .catch(error => {
            console.error(error);
            callback();
          });
      } else {
        callback();
      }
    },

    /**
     * Loads the list of layers associated to the selected workspace and type.
     */
    updateType(e) {
      this.reportParameters[0].value = e;
      this.reportParameters[1].value = undefined;
    },

    /**
     * Loads the list of layers associated to the selected workspace and type.
     */
    loadObjectOptions({ callback }) {
      this.getObjectsToSelectInExport(this.selectedWorkspace).then(objects => {
        this.objectOptions = [];
        objects.forEach(object => {
          this.objectOptions.push({ id: object.code, label: object.name });
        });
        callback();
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/ReportsPages/RawData.vue